import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledActions = styled.div.withConfig({
  displayName: "Actions__StyledActions",
  componentId: "sc-1251ang-0"
})(["grid-area:right;text-align:right;align-items:center;display:flex;"]);
var Actions = /*#__PURE__*/forwardRef(function Actions(_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(StyledActions, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: children
  }));
});

// Actions.displayName = 'eds-topbar-actions'

export { Actions };
